import { render, staticRenderFns } from "./instrument.vue?vue&type=template&id=482ca40d&"
import script from "./instrument.vue?vue&type=script&lang=js&"
export * from "./instrument.vue?vue&type=script&lang=js&"
import style0 from "./instrument.vue?vue&type=style&index=0&id=482ca40d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports